import { useId } from 'react'

import { useAppSelector } from '@/hooks/store'
import { useCartRecapData } from '@/hooks/useCartRecapData.ts'
import { insertPeriodSlice } from '@/store/insertPeriodSlice'
import { PaymentMethod } from '@/store/selectors/selectPaymentMethods'
import { RecapCard } from '../RecapCard'

interface ReservationRecapCardProps {
  nextPath?: string
  paymentMethod?: PaymentMethod
  isFinalPayment?: boolean
  recapData?: ReturnType<typeof useCartRecapData>
  useCartInfoData?: boolean
  isDisabled?: boolean
  totalToPay?: number
}

export const ReservationRecapCard = (props: ReservationRecapCardProps) => {
  const {
    costs,
    deposit,
    total,
    location,
    reservations,
    beachName,
    endDate,
    startDate,
    isRefundable,
    region,
  } = props.recapData ?? useCartRecapData(props.useCartInfoData)
  const bookingPeriod = useAppSelector(
    insertPeriodSlice.selectors.bookingPeriod
  )

  const titleId = useId()
  const descriptionId = useId()
  const headerProps = { descriptionId, isRefundable, titleId }
  const locationProps = {
    beachName,
    bookingPeriod,
    endDate,
    location,
    region,
    startDate,
  }

  const footerProps = {
    ...props,
    total: props.totalToPay ?? total,
  }

  return (
    <RecapCard aria-describedby={descriptionId} aria-labelledby={titleId}>
      <RecapCard.Header {...headerProps} />
      <RecapCard.Location {...locationProps} />
      <hr />
      <RecapCard.Reservations reservations={reservations} />
      <hr />
      <RecapCard.Costs costs={costs} deposit={deposit} total={total} />
      <RecapCard.Footer {...footerProps} />
    </RecapCard>
  )
}
